import Icon from './AidaFramework.icon';

export default {
  Icon,
  getWordCounts: (document) => {
    return [{
      title: 'AIDA',
      value: document.content,
    }];
  },
};
